import { request } from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function getListRegion() {
  return request({
    url: `${ENDPOINT.REGIONS}`,
    method: "get",
  });
}

function switchRegion(data) {
  return request({
    url: `${ENDPOINT.REGION}/switches`,
    method: "post",
    data,
  });
}

export default {
  getListRegion,
  switchRegion,
};
